<template>
  <div v-if="podeCopiarCadastrosEmpresa" class="cadastro-empresa-copiar">
    <button
      type="button"
      class="btn btn-light-primary font-weight-bolder font-size-sm"
      :disabled="quantidadeSelecionada === 0"
      @click="abrirModal"
    >
      Copiar para empresas
      <span v-if="quantidadeSelecionada" class="label label-primary ml-2">
        {{ quantidadeSelecionada }}
      </span>
    </button>

    <b-modal
      ref="modal"
      title="Copiar cadastros para empresas"
      ok-title="Copiar cadastros"
      cancel-title="Cancelar"
      :ok-disabled="empresasSelecionadas.length === 0 || copiando"
      :cancel-disabled="copiando"
      no-close-on-backdrop
      @ok="copiar"
    >
      <p class="mb-4">
        <strong>{{ quantidadeSelecionada }}</strong>
        {{
          quantidadeSelecionada === 1
            ? "registro selecionado"
            : "registros selecionados"
        }}. Escolha as empresas que receberão uma cópia.
      </p>

      <div class="bg-light rounded px-4 py-3 mb-4">
        <span class="text-muted">Empresa de origem:</span>
        <strong class="ml-1">{{ nomeEmpresaCadastro(empresaContexto) }}</strong>
      </div>

      <div class="border rounded px-4 py-3">
        <b-form-checkbox
          v-for="empresa in empresasFiliaisCadastro"
          :key="empresa.id_empresa"
          v-model="empresasSelecionadas"
          :value="Number(empresa.id_empresa)"
          class="mb-2"
        >
          {{ nomeEmpresaCadastro(empresa) }}
          <span class="text-muted ml-1">
            ({{ empresa.tipo_grupo === "MATRIZ" ? "Matriz" : "Filial" }})
          </span>
        </b-form-checkbox>
      </div>

      <small class="text-muted d-block mt-3">
        Cadastros que já existirem na empresa serão mantidos e ignorados.
      </small>
    </b-modal>
  </div>
</template>

<script>
import { actionsStore } from "@/components/Table/actionsStore";
import { cadastroEmpresaCopiaMixin } from "@/modules/GrupoEmpresa/mixins/cadastroEmpresaCopia";

export default {
  name: "CadastroEmpresaCopiarButton",
  mixins: [cadastroEmpresaCopiaMixin],
  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      actionsStore,
      empresasSelecionadas: [],
      copiando: false,
    };
  },
  computed: {
    quantidadeSelecionada() {
      return (this.actionsStore.selectedRows || []).length;
    },
  },
  methods: {
    abrirModal() {
      if (!this.quantidadeSelecionada) return;

      this.empresasSelecionadas = [];
      this.$refs.modal.show();
    },
    async copiar(event) {
      event.preventDefault();
      if (!this.empresasSelecionadas.length || this.copiando) return;

      this.copiando = true;

      try {
        const response = await this.$http.post(
          `/empresa/grupos/${this.empresaContexto.id_grupo_empresa}/cadastros/copiar`,
          {
            modulo: this.modulo,
            registros: this.actionsStore.selectedRows.map((row) =>
              Number(row.id || row.id_pessoa)
            ),
            empresas: this.empresasSelecionadas,
            empresa_origem: Number(this.empresaContexto.id_empresa),
          }
        );
        const resultado = response.data.data || {};
        const detalhes = [];

        if (resultado.existentes) {
          detalhes.push(`${resultado.existentes} já existentes`);
        }
        if (resultado.nao_encontrados) {
          detalhes.push(`${resultado.nao_encontrados} ignorados`);
        }
        if (resultado.dependencias_criadas) {
          detalhes.push(
            `${resultado.dependencias_criadas} vínculos auxiliares criados`
          );
        }

        this.$toast.success(
          `${resultado.criados || 0} cadastros copiados${
            detalhes.length ? `. ${detalhes.join(", ")}.` : "."
          }`
        );
        this.$refs.modal.hide();
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = Date.now();
      } finally {
        this.copiando = false;
      }
    },
  },
};
</script>

<style scoped>
.cadastro-empresa-copiar {
  display: inline-flex;
  align-items: center;
}
</style>
